import React from 'react'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify';
import irelandApi from '../irelandApi';
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'

export const updateSecurityQuestions = (url, payload) => {
  const data = {
    user: {...payload},
  };
  return irelandApi.patch('/api/users/update_security_questions', data)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Security questions updated successfully"/>);
                     history.push(url);
                     store.dispatch(actions.reset('deep.updateSecQ'));
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
                     store.dispatch(actions.resetValidity('deep.updateSecQ.user'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
};

export const updateSecurityQuestionsForAdmin = (url, payload) => {
  const data = {
    user: {...payload},
  };
  return irelandApi.patch('/api/admin/users/security_questions', data)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Security questions updated successfully"/>);
                     history.push(url);
                     store.dispatch(actions.reset('deep.updateSecQ'));
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
                     store.dispatch(actions.resetValidity('deep.updateSecQ.user'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
};

export const updateSecurityQuestionsForOwner = (id, payload) => {
  return irelandApi.patch(`/api/admin/manage_owners/${id}/security_questions`, {user: {...payload}})
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Security questions updated successfully"/>);
                     history.push(`/admin/users/${id}/details`);
                     store.dispatch(actions.reset('deep.updateSecQ'));
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
                     store.dispatch(actions.resetValidity('deep.updateSecQ.user'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
};



// WEBPACK FOOTER //
// ./src/actions/update-security-questions.js